import store from "store/store"

export const setAllCategoryList = (categories) => {
    store.dispatch({
        type: 'CATEGORIES',
        value: categories
    })
}

export const updateWebsiteDetail = (website) => {
    // Save to localStorage
    localStorage.setItem('websiteDetails', JSON.stringify(website));
    localStorage.setItem('websiteDetailsFetchedAt', String(Date.now()));

    // Update Redux store
    store.dispatch({
        type: 'WEBSITE',
        value: website,
    });
};

const WEBSITE_INFO_TTL_MS = 5 * 60 * 1000; // re-check with merchant every 5 min during a live session

// Resets on a hard refresh/new tab (module re-evaluates), so the first
// mount after a reload always fetches. Persists across SPA route changes
// (CustomLayout wraps every page), so in-app navigation only refetches
// once the TTL has actually expired.
let hasFetchedThisSession = false;

export const shouldFetchWebsiteInfo = () => {
    if (!hasFetchedThisSession) return true;
    const fetchedAt = Number(localStorage.getItem('websiteDetailsFetchedAt')) || 0;
    return Date.now() - fetchedAt > WEBSITE_INFO_TTL_MS;
};

export const markWebsiteInfoFetched = () => {
    hasFetchedThisSession = true;
};


export const updateCartCount = (refreshFlag) => {
    // store.dispatch({
    //     type: 'CART_COUNT',
    //     value: count
    // })
    store.dispatch({
        type: 'REFRESH_CART_COUNT',
        value: refreshFlag
    })
}

export const refreshCartCount = (refreshFlag) => {
    store.dispatch({
        type: 'REFRESH_CART_COUNT',
        value: refreshFlag
    })
}

// Single source of truth for the cart bar: count + subtotal in the store
export const setCartSummary = ({ count = 0, subtotal = 0 } = {}) => {
    store.dispatch({
        type: 'CART_SUMMARY',
        value: { count, subtotal }
    })
}